import { render, staticRenderFns } from "./withdrawList.vue?vue&type=template&id=48bd613e&scoped=true&lang=html&"
import script from "./withdrawList.vue?vue&type=script&lang=js&"
export * from "./withdrawList.vue?vue&type=script&lang=js&"
import style0 from "./withdrawList.vue?vue&type=style&index=0&id=48bd613e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd613e",
  null
  
)

export default component.exports